import {API} from 'aws-amplify';
import axios from 'axios';

const isLocalAuth = process.env.REACT_APP_LOCAL_AUTH === 'true';
const baseURL = process.env.REACT_APP_APIURL;

export async function saveEmailConfig(configObj: any) {
  const { code } = configObj;
  if (isLocalAuth) return axios.post(`${baseURL}/email/config`, { code }).then(r => r.data);
  return API.post('Backend', "/email/config", { body: { code } });
}
export async function getUserConfig() {
  if (isLocalAuth) return axios.get(`${baseURL}/email/config`).then(r => r.data);
  return API.get('Backend', "/email/config", {});
}
export async function deleteConfig(id: any) {
  if (isLocalAuth) return axios.delete(`${baseURL}/email/config`, { params: { id } }).then(r => r.data);
  return API.del('Backend', "/email/config", { queryStringParameters: { id: id } });
}
